import styled from 'styled-components';

// eslint-disable-next-line import/prefer-default-export
export const EmptyProjectsContainer = styled.div`
	margin: ${({ theme }) => theme.spacing(2)} 0 ${({ theme }) => theme.spacing(2)}
		${({ theme }) => theme.spacing(5)};
`;
